import { render, staticRenderFns } from "./ComparisonsSub.vue?vue&type=template&id=d2cf3c02&scoped=true&"
import script from "./ComparisonsSub.vue?vue&type=script&lang=js&"
export * from "./ComparisonsSub.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonsSub.vue?vue&type=style&index=0&id=d2cf3c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cf3c02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VRow,VTooltip})
